import { nanoid } from 'nanoid';

import { type ExtendToRowEvent } from '../events/types';
import { type SelectionRange, type SelectionState } from '../state/types';

import { type ReducerResponse } from './types';

export function extendToRowReducer(
  state: SelectionState,
  event: ExtendToRowEvent
): ReducerResponse {
  const anchor = state.focusedCell ?? {
    row: event.row,
    col: { index: 0 },
  };
  const lead = {
    row: event.row,
    col: anchor.col,
  };

  if (state.mode === 'row' && state.selections.length === 1) {
    const existing = state.selections[0];
    const updatedSelection: SelectionRange = {
      ...existing,
      lead,
    };

    return {
      delta: {
        kind: 'selectionModified',
        source: event.source,
        updated: [updatedSelection],
      },
      next: {
        ...state,
        selections: [updatedSelection],
        lastInteractionSource: event.source,
      },
    };
  }

  const newSelection: SelectionRange = {
    id: nanoid(),
    anchor,
    lead,
  };

  return {
    delta: {
      kind: 'selectionReplaced',
      source: event.source,
      selections: [newSelection],
      focusChange: state.focusedCell ? undefined : { prev: null, next: anchor },
    },
    next: {
      ...state,
      mode: 'row',
      focusedCell: state.focusedCell ?? anchor,
      selections: [newSelection],
      lastInteractionSource: event.source,
    },
  };
}
